<dialog [modal]="true" id="market-segment-selector" [canClose]="false">
    <img [use]="media" role="presentation" width="135" height="54">
    <p>{{ description }}</p>
    <div class="segments">
        @for(segment of segments; track segment) {
            <div class="segment">
                <button [class]="segment" (click)="selectSegment(segment)">{{ 'MARKET_SEGMENT.'+segment+'_BUTTON' | uppercase | translate }}</button>
                <span>{{ 'MARKET_SEGMENT.'+segment+'_VAT' | uppercase | translate }}</span>
            </div>
        }
    </div>
</dialog>
